import { useEffect, useState } from "react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { EditButton } from "components/Shared/Panel/Editable";
import SimplePanel from "components/Shared/Panel/Simple";
import BrandSettingsCompanyInformationEdit from "./Edit";
import BrandSettingsCompanyInformationView from "./View";

const fragment = gql(/* GraphQL */ `
  fragment BrandSettingsCompanyInformationFields on Brand {
    id
    ...BrandSettingsCompanyInformationViewFields
    ...BrandSettingsCompanyInformationEditFields
  }
`);

type Props = {
  brand: FragmentType<typeof fragment> | null | undefined;
  isLoading?: boolean;
};

export default function BrandSettingsCompanyInformation({
  brand: brandFragmentData,
  isLoading,
}: Props) {
  const brand = getFragmentData(fragment, brandFragmentData);
  const [isEditing, setIsEditing] = useState(false);
  const brandId = brand?.id;

  useEffect(() => {
    setIsEditing(false);
  }, [brandId]);

  return (
    <SimplePanel
      heading="Company Information"
      header={
        <EditButton
          isOpen={isEditing}
          onClick={
            isEditing ? () => setIsEditing(false) : () => setIsEditing(true)
          }
          disabled={!!isLoading || !brandId}
          ml="auto"
        />
      }
      mt={14}
    >
      {isEditing ? (
        <BrandSettingsCompanyInformationEdit
          brand={brand}
          isLoading={isLoading}
          onCancel={() => setIsEditing(false)}
          onSaved={() => setIsEditing(false)}
        />
      ) : (
        <BrandSettingsCompanyInformationView
          brand={brand}
          isLoading={isLoading}
        />
      )}
    </SimplePanel>
  );
}
